import styles from "./styles.module.scss";
import { FC } from "react";
import { Props } from "./typings";
import CloseIcon from "assets/icons/close.svg?react";
import ChatView from "components/ChatView";

const ChatModal: FC<Props> = ({ chatId, toggle }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        Chat
        <CloseIcon onClick={() => toggle(false)} className={styles.closeIcon} />
      </div>
      <div className={styles.content}>
        <ChatView chatId={chatId}></ChatView>
      </div>
    </div>
  );
};

export default ChatModal;
